import { context, metrics, propagation, trace } from '@opentelemetry/api';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { MeterProvider, PeriodicExportingMetricReader } from '@opentelemetry/sdk-metrics';
import { BatchSpanProcessor, StackContextManager, TracerProvider } from '@opentelemetry/sdk-trace';
import CustomSpanProcessor from './spanprocessor';
const DEFAULT_ENDPOINT = 'https://ingest.us.signoz.cloud:443';
function getHeaders(ingestionKey) {
    return ingestionKey ? { 'signoz-ingestion-key': ingestionKey } : undefined;
}
export function initializeFrontendInstrumentation(config) {
    const endpoint = config.endpoint || DEFAULT_ENDPOINT;
    const headers = getHeaders(config.ingestionKey);
    const exporter = new OTLPTraceExporter({
        url: `${endpoint}/v1/traces`,
        headers,
    });
    const resource = resourceFromAttributes({
        'service.name': config.serviceName,
        'service.version': config.serviceVersion || 'local-testing',
        'deployment.environment': config.environment || 'local',
    });
    const provider = new TracerProvider({
        resource,
        spanProcessors: [new BatchSpanProcessor({ exporter }), CustomSpanProcessor],
    });
    trace.setGlobalTracerProvider(provider);
    context.setGlobalContextManager(new StackContextManager().enable());
    propagation.setGlobalPropagator(new W3CTraceContextPropagator());
    registerInstrumentations({
        instrumentations: [
            new DocumentLoadInstrumentation(),
            new FetchInstrumentation({
                // Selects which backend servers are allowed to receive trace headers for linking traces across services.
                // Using /.*/ acts as a wildcard. For safer usage in production, replace with specific domains.
                propagateTraceHeaderCorsUrls: /.*/,
            }),
            new UserInteractionInstrumentation({
                eventNames: ['click', 'input', 'submit'],
            }),
            new XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls: /.*/,
            }),
        ],
    });
    const metricReader = new PeriodicExportingMetricReader({
        exporter: new OTLPMetricExporter({
            url: `${endpoint}/v1/metrics`,
            headers,
        }),
        exportIntervalMillis: 10000,
    });
    const meterProvider = new MeterProvider({
        resource,
        readers: [metricReader],
    });
    metrics.setGlobalMeterProvider(meterProvider);
}
